import firebase from 'firebase/app';
import { get } from '../../api/client';
import { FarmGroup } from './farmGroupType';

export const getFarmGroups = async (): Promise<FarmGroup[]> => {
    const token = await firebase.auth().currentUser?.getIdToken();
    return await get(token!, 'farm-groups');
};
